
import Demographics from '../Components/Demographics';
import Pagehelmet from './Pagehelmet';
import SponsorshipTable from '../Components/SponsorshipTable';
import SponsorForm from '../Components/SponsorForm';
import {
  FaGlobe,
  FaUsers,
  FaBullhorn,
  FaTicketAlt,
  FaLaptop,
  FaHandshake
} from "react-icons/fa";

const BecomeSponsor = () => {


  return (
    <div>
      <Pagehelmet title="Sponsorship & Benefits" />

      <section
        style={{
          background: "linear-gradient(135deg, rgba(2, 25, 53, 1) 0%, #fff 100%)",
          padding: "80px 0",
          textAlign: "center",
        }}
      >
        <div className="container">


          {/* Main Title */}
          <h2
            style={{
              fontWeight: "800",
              fontSize: "2.2rem",
              color: "rgba(255, 255, 255, 1)",
              marginBottom: "20px",
            }}
          >
            Become a Sponsor and Unlock Exclusive Opportunities
          </h2>

          {/* Description */}
          <p
            style={{
              fontSize: "1rem",
              color: "#ffffffff",
              maxWidth: "850px",
              margin: "0 auto",
              lineHeight: "1.8",
            }}
          >
            Partner with <strong>FutureOil 2026</strong> and leverage the power
            of a high-profile virtual platform that connects you directly with
            industry leaders, decision-makers, and innovators from around the
            globe. Our virtual conference offers unmatched visibility and
            meaningful engagement with a targeted, high-value audience.
          </p>
        </div>
      </section>

      <SponsorshipTable />

      <section
        style={{
          padding: "80px 0",
          backgroundColor: "#f9f9f9",
          fontFamily: "'Inter', sans-serif",
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center mb-5">
              <h2
                style={{
                  fontWeight: "800",
                  fontSize: "2.4rem",
                  marginBottom: "20px",
                }}
              >
                Why Sponsor Futureoil 2026?
              </h2>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 mb-4">
              <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                {[
                  {
                    icon: <FaGlobe size={20} />,
                    title: "Access a Global, Engaged Audience",
                    desc: "Our virtual format attracts diverse professionals worldwide, giving your brand maximum exposure to potential clients actively seeking cutting-edge solutions and partnerships.",
                  },
                  {
                    icon: <FaUsers size={20} />,
                    title: "Generate Qualified Leads and New Business",
                    desc: "Interact with attendees who have significant budgets and are eager to invest in innovative technologies and services that can drive their digital transformation journey.",
                  },
                  {
                    icon: <FaBullhorn size={20} />,
                    title: "Boost Brand Awareness and Thought Leadership",
                    desc: "Your brand will be prominently featured across the virtual exhibition space, conference website, program, and digital marketing channels, positioning you as a key player in the energy sector’s digital future.",
                  },
                ].map((item, i) => (
                  <li key={i} style={{ marginBottom: "30px", display: "flex" }}>
                    <div
                      style={{
                        width: "42px",
                        height: "42px",
                        background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
                        borderRadius: "12px",
                        marginTop: "2px",
                        marginRight: "14px",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        boxShadow: "0 4px 10px rgba(37,117,252,0.35)",
                      }}
                    >
                      {item.icon}
                    </div>
                    <div>
                      <h5 style={{ fontWeight: "700", marginBottom: "6px" }}>{item.title}</h5>
                      <p
                        style={{
                          fontSize: "0.95rem",
                          color: "#555",
                          lineHeight: "1.7",
                          margin: 0,
                        }}
                      >
                        {item.desc}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-lg-6 mb-4">
              <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                {[
                  {
                    icon: <FaTicketAlt size={20} />,
                    title: "Complimentary Virtual Passes",
                    desc: "Receive exclusive access passes to share with your customers, partners, and internal teams—enhancing networking and business development opportunities.",
                  },
                  {
                    icon: <FaLaptop size={20} />,
                    title: "Showcase Products and Solutions Live",
                    desc: "Host virtual demos, live Q&A sessions, and interactive meetings in your branded virtual booth, enabling meaningful connections and real-time conversations with prospects worldwide.",
                  },
                  {
                    icon: <FaHandshake size={20} />,
                    title: "Build and Strengthen Client Relationships",
                    desc: "Engage seamlessly with current clients and new contacts in a dynamic virtual environment designed to foster collaboration and strategic discussions.",
                  },
                ].map((item, i) => (
                  <li key={i} style={{ marginBottom: "30px", display: "flex" }}>
                    <div
                      style={{
                        width: "42px",
                        height: "42px",
                        background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
                        borderRadius: "12px",
                        marginTop: "2px",
                        marginRight: "14px",
                        flexShrink: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        boxShadow: "0 4px 10px rgba(37,117,252,0.35)",
                      }}
                    >
                      {item.icon}
                    </div>
                    <div>
                      <h5 style={{ fontWeight: "700", marginBottom: "6px" }}>{item.title}</h5>
                      <p
                        style={{
                          fontSize: "0.95rem",
                          color: "#555",
                          lineHeight: "1.7",
                          margin: 0,
                        }}
                      >
                        {item.desc}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>





      <SponsorForm />






      <section
        style={{
          backgroundColor: "#f8f9fa",
          padding: "60px 0",
          fontFamily: "'Inter', sans-serif",
        }}
      >      <div className="container" style={{ maxWidth: "1200px", margin: "0 auto" }}>

          <h2
            style={{
              textAlign: "center",
              fontWeight: "800",
              fontSize: "2rem",
              marginBottom: "40px",
              color: "#000",
            }}
          >
            Return on Investments!
          </h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "20px",
            }}
          >
            {[
              {
                title: "🎯 High-Impact Branding",
                desc: "Enjoy premium logo placement across the website, event agenda, email campaigns, and live session intermissions.",
              },
              {
                title: "🎙️ Sponsored Speaking Slot",
                desc: "Host a keynote or join a high-visibility panel discussion to showcase your leadership and expertise.",
              },
              {
                title: "🛍️ Virtual Booth & Showcase",
                desc: "Share brochures, case studies, demo videos, and contact forms with attendees through your custom sponsor profile.",
              },
              {
                title: "📊 Lead Generation & Reporting",
                desc: "Receive detailed post-event reports including attendee engagement metrics, contact leads (opt-in), and booth interaction stats.",
              },
              {
                title: "🤝 1-on-1 Meetings & Demo Scheduling",
                desc: "Engage attendees directly through pre-scheduled meetings, live chat, and on-demand demo sessions.",
              },
              {
                title: "📢 Social Media & Content Promotion",
                desc: "Be featured in pre-event and post-event LinkedIn campaigns, newsletters, and speaker spotlights.",
              },
              {
                title: "💼 Sponsorship Tiers to Fit Your Goals",
                desc: "Choose from flexible packages (Gold, Silver, Bronze) designed to suit your brand’s strategic objectives and budget.",
              },
            ].map((pkg, idx) => (
              <div
                key={idx}
                style={{
                  backgroundColor: "#fff",
                  padding: "25px",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "1.2rem",
                    color: "#000",
                    marginBottom: "10px",
                  }}
                >
                  {pkg.title}
                </h3>
                <p style={{ fontSize: "0.95rem", color: "#555", lineHeight: "1.6" }}>
                  {pkg.desc}
                </p>
              </div>
            ))}
          </div>

        </div>
      </section>

      <Demographics />



    </div>
  );
};

export default BecomeSponsor;
